/** Pages paramètres au niveau entreprise (navbar : onglets + switch). */
export const SETTINGS_COMPANY_PAGE_TYPES = new Set([
  "settings_team",
  "settings_time_management",
]);

/** Pages paramètres au niveau organisation (navbar : onglets, sans switch entreprise). */
export const ORGANIZATION_SETTINGS_PAGE_TYPES = new Set([
  "organization_settings",
  "organization_settings_companies",
]);

export const ORGANIZATION_SETTINGS_PAGE_TYPE = "organization_settings";
